var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',_vm._b({class:_vm.computedClasses,style:(_vm.computedTextStyles),domProps:{"innerHTML":_vm._s(_vm.computedHtml)}},'h1',{ id: _vm.id },false))}
var staticRenderFns = []

export { render, staticRenderFns }